import {WebFormModelOptions} from 'capitalist-shared/src/core/model';
import {MoneyAmount} from '@/models/finance/money';
import {CurrencyCode} from "@/models/core/currency";
import {config, PaywayConfig} from "@/components/forms/payout/payways/dropdown.payways";


export interface PayoutEstimatedTaxInterface {
  tax: number
  feeAmount: number
  feeCurrency: CurrencyCode
}

export interface PayoutTaxRuleInterface {
  base: number
  fix: MoneyAmount[]
  min: MoneyAmount
}

export interface EvaluateReverseFeeResultInterface {
  fee: number
  currency: string
  amount: number
  diff: number
}

export interface PayoutWebModelOptions extends WebFormModelOptions {
  allaccounts: any[],
  accounts: any[],
  verification: [],
  sourceCurrency: string | null,
  sourceAccountsCardsPro: boolean,
  taxRule: any,
  notifiable: boolean,
  destCurrency: CurrencyCode[]
  notificationChannels: any[]
  autosplit: boolean
}

export const tns = (key: string, ns: string, proxy, locale) => {
  if (!key) return key;
  const xkey = ns + '.' + key;
  const result = proxy.$t(xkey, locale, []);
  if (!result || (result == xkey)) return key;
  return result;
}

export const getPaywayConfig = (system: string, id: string = null): PaywayConfig | null => {
  return config.find((item: any) => {
      return (item.system == system) && (!id || item.id == id)
    }
  );
}
export const getPaywayConfigs = (system: string): PaywayConfig[] => {
  return config.filter((item: any) => item.system == system);
}


const accountsCurrencyWeights = {
  [CurrencyCode.RUR]: 1,
  [CurrencyCode.USD]: 2,
  [CurrencyCode.EUR]: 3,
  [CurrencyCode.BTC]: 4,
  [CurrencyCode.ETH]: 5,
  [CurrencyCode.USDT]: 6,
  [CurrencyCode.USDTt]: 7,
  [CurrencyCode.USDC]: 8,
  [CurrencyCode.BCC]: 9,
};

const accountsAutoconvertCurrencyWeights = {
  [CurrencyCode.USD]: 1,
  [CurrencyCode.EUR]: 2,
  [CurrencyCode.RUR]: 3,
};

export const accountsCurrencyWeight = (currency, defaultWeight = 100) => {
  if (accountsCurrencyWeights[currency]) return accountsCurrencyWeights[currency];
  accountsCurrencyWeights[currency] = defaultWeight + Object.keys(accountsCurrencyWeights).length;
  return accountsCurrencyWeights[currency] || defaultWeight;
}

export const accountsAutoconvertCurrencyWeight = (currency, defaultWeight = 100) => {
  if (accountsAutoconvertCurrencyWeights[currency]) return accountsAutoconvertCurrencyWeights[currency];
  accountsAutoconvertCurrencyWeights[currency] = defaultWeight + Object.keys(accountsAutoconvertCurrencyWeights).length;
  return accountsAutoconvertCurrencyWeights[currency] || defaultWeight;
}

export const accountsCurrencySortingCb = (a, b) => {
  return accountsCurrencyWeight(a.currency) - accountsCurrencyWeight(b.currency);
}

export const accountsAutoconvertCurrencySortingCb = (a, b) => {
  return accountsAutoconvertCurrencyWeight(a.currency) - accountsAutoconvertCurrencyWeight(b.currency);
}

export const accountsNumberSortingCb = (a, b) => {
  return String(a.number).localeCompare(String(b.number));
}

export const accountsBalanceSortingCb = (a, b) => {
  return b.availBalance - a.availBalance;
}
